export const ArrayOfLength = (length: number) => Array.from({ length }, (v, i) => i);